import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRight, ShoppingCart, Check, Droplets, Flame, Sparkles, Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

const PRODUCTS = {
  'buzzing-gel': {
    id: 'buzzing-gel',
    name: "ג'ל עוררות Buzzing",
    subtitle: 'תפנק את בת הזוג',
    tagline: 'תחושת זמזום מעוררת להנאה מוגברת',
    price: 299,
    oldPrice: 399,
    image: '/products/buzzing.webp',
    color: 'pink',
    rating: '4.7',
    reviews: 55,
    size: '0.5 FL Oz (15ml)',
    highlights: [
      'תחושת זמזום מרגשת ומעוררת',
      'מגביר רגישות למגע באינטימיות',
      'בטוח לשימוש אוראלי, מיוצר בארה"ב',
    ],
    features: [
      {
        icon: 'sparkles',
        title: 'תחושת זמזום',
        desc: 'הוסיפי עוד להנאה עם ג\'ל שמזמזם ומדגדג תוך 5 דקות',
      },
      {
        icon: 'droplets',
        title: 'פורמולת ג\'ל קלה',
        desc: 'מועשר בנוגדי חמצון, בסיס שמן לתחושה חלקה ומשיית',
      },
      {
        icon: 'flame',
        title: 'מעורר להפליא',
        desc: 'מיועד לאזורים הרגישים ביותר תוך הגברת תחושת המגע',
      },
    ],
    howToUse: [
      { step: 'סחטי טיפה קטנה', desc: 'מריחים כמות קטנה בגודל אפונה על האצבע. ניתן להוסיף עוד לפי הצורך.' },
      { step: 'מריחים על האזורים הרגישים', desc: 'עיסוי עדין על הדגדגן, סביב הקליטוריס והשפתיים.' },
      { step: 'נהנים!', desc: 'חוויית אורגזמה כמו שלא חשבת שאפשרי. עד 75 שימושים בשפורפרת אחת.' },
    ],
    ingredients: 'Isononyl Isononanoate, Isopropyl Palmitate, Oleyl Alcohol, Zanthoxylum Alatum Extract, Ethylene/Propylene/Styrene Copolymer, Helianthus Annuus (Sunflower) Seed Extract, Rosmarinus Ocinalis (Rosemary) Leaf Extract, Tetrasodium Glutamate Diacetate',
    badges: ['ללא פרבנים', 'ללא הורמונים', 'מיוצר בארה"ב', 'עד 75 שימושים'],
  },
  'warming-gel': {
    id: 'warming-gel',
    name: "ג'ל עוררות Warming",
    subtitle: 'תפנק את בת הזוג',
    tagline: 'תחושת חימום מעוררת לרגישות מוגברת',
    price: 299,
    oldPrice: 399,
    image: '/products/warming.webp',
    color: 'red',
    rating: '4.6',
    reviews: 294,
    size: '0.5 FL Oz (15ml)',
    highlights: [
      'תחושת חימום, זמזום ודגדוג',
      'מגביר זרימת דם לדגדגן לעוררות מוגברת',
      'מיוצר בארה"ב, ללא פרבנים והורמונים',
    ],
    features: [
      {
        icon: 'flame',
        title: 'תחושת חימום',
        desc: 'תחושת חימום עדינה ומזמזמת שיוצרת אפקט מענג תוך 5 דקות',
      },
      {
        icon: 'droplets',
        title: 'עדין וחלק כמשי',
        desc: 'מכיל חומר סיכה היברידי ליצירת לחות ארוכת טווח עם גימור חלק',
      },
      {
        icon: 'sparkles',
        title: 'מעורר להפליא',
        desc: 'מיועד לאזורים הרגישים ביותר תוך הגברת ההנאה המינית',
      },
    ],
    howToUse: [
      { step: 'סחטי טיפה קטנה', desc: 'מריחים כמות קטנה בגודל אפונה על האצבע. ניתן להוסיף עוד לפי הצורך.' },
      { step: 'מריחים על האזורים הרגישים', desc: 'עיסוי עדין על הדגדגן, סביב הקליטוריס והשפתיים.' },
      { step: 'נהנים מהחימום!', desc: 'אורגזמות ברמה שלא חשבתם שאפשרית. עד 75 שימושים בשפורפרת.' },
    ],
    ingredients: 'Glycerin, Deionized Water (Aqua), Dimethiconol, Sodium Polyacrylate, Dimethicone, Cyclopentasiloxane, Trideceth-6, PEG/PPG-18/18 Dimethicone, Pentylene Glycol, Hyaluronic Acid, Hydroxyacetophenone, Mentha Piperita (Peppermint), Methyl Nicotinate, Vanillyl Butyl Ether',
    badges: ['ללא פרבנים', 'ללא הורמונים', 'מיוצר בארה"ב', 'עד 75 שימושים'],
  },
};

const FeatureIcon = ({ type, color }) => {
  const cls = `w-8 h-8 ${color === 'pink' ? 'text-pink-500' : 'text-red-500'}`;
  if (type === 'sparkles') return <Sparkles className={cls} />;
  if (type === 'droplets') return <Droplets className={cls} />;
  if (type === 'flame') return <Flame className={cls} />;
  return <Heart className={cls} />;
};

// Grid view showing both products
const ProductGrid = ({ onSelect, addToCart, addedItems, showPopup }) => {
  const navigate = useNavigate();
  return (
    <div className="container py-8" data-testid="partner-products-page">
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}
      <button onClick={() => navigate('/products')} className="flex items-center gap-2 text-[#2C3E2D] hover:text-pink-500 transition-colors mb-8" data-testid="back-button">
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-bold text-[#2C3E2D] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>תפנק את בת הזוג</h1>
        <p className="text-base md:text-lg text-stone-500">מוצרים שיהפכו את בת הזוג שלך ליותר מאושרת</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
        {Object.values(PRODUCTS).map((product) => (
          <div key={product.id} onClick={() => onSelect(product.id)} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-stone-200 hover:border-pink-300 hover:shadow-xl transition-all duration-300 cursor-pointer group">
            <div className="bg-white p-6 flex items-center justify-center" style={{ minHeight: '300px' }}>
              <img src={product.image} alt={product.name} className="max-w-full max-h-72 object-contain group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div className="p-6 text-center">
              <h3 className="text-xl font-bold text-[#2C3E2D] mb-1" style={{ fontFamily: 'Heebo, sans-serif' }}>{product.name}</h3>
              <p className="text-stone-500 text-sm mb-4">{product.tagline}</p>
              <div className={`mb-4 flex items-baseline gap-2 ${product.color === 'pink' ? 'text-pink-500' : 'text-red-500'}`} style={{ fontFamily: 'Heebo, sans-serif' }}>
                {product.oldPrice && product.oldPrice > product.price && (
                  <span className="text-lg text-stone-400 line-through">{product.oldPrice} ש"ח</span>
                )}
                <span className="text-3xl font-bold">{product.price} ש"ח</span>
              </div>
              <div className={`inline-block px-6 py-3 rounded-full font-bold text-white ${product.color === 'pink' ? 'bg-pink-500 group-hover:bg-pink-600' : 'bg-red-500 group-hover:bg-red-600'} transition-colors`} style={{ fontFamily: 'Heebo, sans-serif' }}>
                לפרטים נוספים
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Detail view for a single product
const ProductDetail = ({ product, onBack, addToCart, added, showPopup }) => {
  const navigate = useNavigate();
  const accent = product.color === 'pink' ? 'pink' : 'red';
  const accentBg = accent === 'pink' ? 'bg-pink-500' : 'bg-red-500';
  const accentHover = accent === 'pink' ? 'hover:bg-pink-600' : 'hover:bg-red-600';
  const accentText = accent === 'pink' ? 'text-pink-500' : 'text-red-500';
  const accentBorder = accent === 'pink' ? 'border-pink-200' : 'border-red-200';
  const accentBgLight = accent === 'pink' ? 'bg-pink-50' : 'bg-red-50';

  const handleButtonClick = () => {
    if (added) {
      navigate('/cart');
    } else {
      addToCart(product);
    }
  };

  return (
    <div className="container py-8" data-testid={`product-detail-${product.id}`}>
      {showPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-bounce">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}

      <button onClick={onBack} className="flex items-center gap-2 text-[#2C3E2D] hover:text-pink-500 transition-colors mb-8" data-testid="back-to-grid">
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה למוצרים</span>
      </button>

      {/* Hero Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white rounded-2xl p-8 flex items-center justify-center border border-stone-100 shadow-sm">
          <img src={product.image} alt={product.name} className="max-w-full max-h-96 object-contain" />
        </div>
        <div className="flex flex-col justify-center" style={{ direction: 'rtl' }}>
          <p className={`text-sm font-semibold ${accentText} mb-2`}>תפנק את בת הזוג</p>
          <h1 className="text-3xl md:text-4xl font-bold text-[#2C3E2D] mb-3" style={{ fontFamily: 'Heebo, sans-serif' }}>{product.name}</h1>
          <div className="flex items-center gap-3 mb-4">
            <span className="text-yellow-500">{'★'.repeat(Math.round(parseFloat(product.rating)))}</span>
            <span className="text-sm text-stone-500">{product.rating} ({product.reviews} ביקורות)</span>
          </div>
          <p className="text-stone-600 text-lg mb-4">{product.tagline}</p>
          <p className="text-stone-400 text-sm mb-6">{product.size}</p>

          <ul className="space-y-2 mb-6">
            {product.highlights.map((h, i) => (
              <li key={i} className="flex items-start gap-2">
                <Check className={`w-5 h-5 mt-0.5 flex-shrink-0 ${accentText}`} />
                <span className="text-stone-700">{h}</span>
              </li>
            ))}
          </ul>

          <div className={`mb-6 flex items-baseline gap-3 ${accentText}`} style={{ fontFamily: 'Heebo, sans-serif' }}>
            {product.oldPrice && product.oldPrice > product.price && (
              <span className="text-2xl text-stone-400 line-through">{product.oldPrice} ש"ח</span>
            )}
            <span className="text-4xl font-bold">{product.price} ש"ח</span>
          </div>

          <button
            onClick={handleButtonClick}
            data-testid={`buy-${product.id}`}
            className={`w-full flex items-center justify-center gap-3 px-6 py-4 rounded-full font-bold text-lg text-white transition-all duration-300 hover:shadow-lg ${added ? 'bg-green-500 hover:bg-green-600' : `${accentBg} ${accentHover}`}`}
            style={{ fontFamily: 'Heebo, sans-serif' }}
          >
            <ShoppingCart className="w-5 h-5" />
            {added ? 'מעבר לרכישה' : 'הוסף לסל'}
          </button>

          <div className="flex flex-wrap gap-2 mt-6">
            {product.badges.map((badge, i) => (
              <span key={i} className={`px-3 py-1 rounded-full text-xs font-medium border ${accentBorder} ${accentBgLight} ${accentText}`}>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold text-[#2C3E2D] text-center mb-8" style={{ fontFamily: 'Heebo, sans-serif' }}>מה הופך את המוצר הזה למיוחד</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {product.features.map((f, i) => (
            <div key={i} className={`bg-white rounded-2xl p-6 text-center border ${accentBorder} shadow-sm`}>
              <div className="flex justify-center mb-4">
                <FeatureIcon type={f.icon} color={product.color} />
              </div>
              <h3 className="font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>{f.title}</h3>
              <p className="text-stone-500 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* How to Use */}
      <div className={`${accentBgLight} rounded-2xl p-8 mb-12`}>
        <h2 className="text-2xl font-bold text-[#2C3E2D] text-center mb-8" style={{ fontFamily: 'Heebo, sans-serif' }}>איך להשתמש</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {product.howToUse.map((step, i) => (
            <div key={i} className="text-center">
              <div className={`w-12 h-12 rounded-full ${accentBg} text-white flex items-center justify-center text-xl font-bold mx-auto mb-4`}>
                {i + 1}
              </div>
              <h3 className="font-bold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>{step.step}</h3>
              <p className="text-stone-600 text-sm">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Ingredients */}
      <div className="bg-white rounded-2xl p-8 border border-stone-200 mb-12">
        <h2 className="text-2xl font-bold text-[#2C3E2D] text-center mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>רכיבים</h2>
        <p className="text-stone-500 text-sm text-center leading-relaxed" dir="ltr">{product.ingredients}</p>
      </div>

      {/* Bottom CTA */}
      <div className="text-center">
        <button
          onClick={handleButtonClick}
          data-testid={`buy-bottom-${product.id}`}
          className={`inline-flex items-center justify-center gap-3 px-12 py-4 rounded-full font-bold text-lg text-white transition-all duration-300 hover:shadow-lg ${added ? 'bg-green-500 hover:bg-green-600' : `${accentBg} ${accentHover}`}`}
          style={{ fontFamily: 'Heebo, sans-serif' }}
        >
          <ShoppingCart className="w-5 h-5" />
          {added ? 'מעבר לרכישה' : `הוסף לסל - ${product.price} ש"ח`}
        </button>
      </div>
    </div>
  );
};

const PartnerProducts = () => {
  const { productId } = useParams();
  const [selectedProduct, setSelectedProduct] = useState(productId || null);
  const [addedItems, setAddedItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const { addToCart: cartAdd } = useCart();

  const handleAddToCart = (product) => {
    cartAdd({
      id: product.id,
      name: product.name,
      description: product.tagline,
      price: product.price,
      image: product.image,
      quantity: 1
    });
    playCartSound();
    setAddedItems(prev => ({ ...prev, [product.id]: true }));
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 2000);
  };

  if (selectedProduct && PRODUCTS[selectedProduct]) {
    const product = PRODUCTS[selectedProduct];
    return (
      <ProductDetail
        product={product}
        onBack={() => setSelectedProduct(null)}
        addToCart={() => handleAddToCart(product)}
        added={addedItems[product.id]}
        showPopup={showPopup}
      />
    );
  }

  return (
    <ProductGrid
      onSelect={(id) => setSelectedProduct(id)}
      addToCart={handleAddToCart}
      addedItems={addedItems}
      showPopup={showPopup}
    />
  );
};

export default PartnerProducts;
